import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { getFromStorage } from '../storage'
import { storageKey } from '../../constants/storage'

export function checkTokenDate() {
  dayjs.extend(utc)
  const LS_DATA = getFromStorage(storageKey.USER)
  if (LS_DATA?.expires_at) {
    const isExpired = dayjs
      .utc()
      .isAfter(dayjs.utc(LS_DATA.expires_at).format())
    return isExpired
  }
}
